import styled from 'styled-components';

// number of pixels occupied by the text area's top, left padding + border
const textPaddingPixelsTopLeft = 3;

export const LogEventDetailsWrapper = styled.div`
  border-radius: 4px;
  border: solid 1px #dedede;
  padding-top: ${30 - textPaddingPixelsTopLeft}px;
  padding-right: ${30 - textPaddingPixelsTopLeft}px;
  padding-bottom: ${15 - textPaddingPixelsTopLeft}px;
  padding-left: ${30 - textPaddingPixelsTopLeft}px;
`;

export const LogEventDetailsText = styled.div`
  margin-bottom: 15px;
  padding-top: ${textPaddingPixelsTopLeft}px;
  padding-left: ${textPaddingPixelsTopLeft}px;
  white-space: pre-line;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  color: black;
`;
